module.exports = __webpack_public_path__ + "static/media/118.af60feb5.jpg";